export const en = {
  title: 'Legal Notice',
  subtitle: 'Mandatory information pursuant to EU Regulation 2018/302 and the Estonian Commercial Code (äriseadustik) · As of 10.05.2026',
  sections: [
    {
      id: 'company',
      title: 'Service Provider',
      body:
        '**MATTALNET GRUPP OÜ**\nTuukri tn 19-315\n10120 Tallinn, Estonia\n\n- **Registrikood (commercial register number):** 14744075\n- **VAT ID / KMKR number:** EE102519059\n- **EORI:** EE14744075\n- **D-U-N-S:** 536415812\n- **Register:** Eesti äriregister (Estonian Commercial Register)\n- **Legal form:** Osaühing (OÜ) — private limited company under Estonian law\n- **Authorised and regulated in:** Republic of Estonia, European Union',
    },
    {
      id: 'responsible',
      title: 'Person Responsible for Content',
      body:
        '**Andreas A. Gleim**\nManaging Director / Responsible for content pursuant to the Estonian Commercial Code (äriseadustik) and § 18 MStV (Germany)\n\nE-mail: [logixa.one/kontakt](/kontakt)',
    },
    {
      id: 'contact',
      title: 'Contact',
      body:
        'E-mail: [logixa.one/kontakt](/kontakt)\nWebsite: [https://logixa.one](https://logixa.one)\n\nInquiries regarding the platform, partnerships, press, and data protection can reach us via the [contact form](/kontakt).',
    },
    {
      id: 'eu',
      title: 'EU Dispute Resolution',
      body:
        'The European Commission provides a platform for online dispute resolution (ODR):\n\n[https://ec.europa.eu/consumers/odr/](https://ec.europa.eu/consumers/odr/)\n\nWe are neither willing nor obliged to participate in dispute resolution proceedings before a consumer arbitration board.',
    },
    {
      id: 'liability',
      title: 'Liability for Content',
      body:
        'As a service provider, we are responsible for our own content on these pages in accordance with § 7 para. 1 TMG (Germany) and the Estonian InfoTS under the general laws. However, pursuant to §§ 8 to 10 TMG, we as a service provider are not obliged to monitor transmitted or stored third-party information.\n\nObligations to remove or block the use of information under the general laws remain unaffected by this. Liability in this regard is, however, only possible from the point in time at which a concrete infringement of the law becomes known.',
    },
    {
      id: 'liability-links',
      title: 'Liability for Links',
      body:
        'Our offering contains links to external third-party websites over whose content we have no influence. For this reason, we cannot assume any liability for this third-party content. The respective provider or operator of the pages is always responsible for the content of the linked pages.',
    },
    {
      id: 'copyright',
      title: 'Copyright',
      body:
        'The content and works created by the site operators on these pages are subject to copyright. Reproduction, editing, distribution, and any kind of exploitation outside the limits of copyright require the written consent of the respective author or creator.\n\nDownloads and copies of this page are permitted only for private, non-commercial use.',
    },
  ],
};
